<template>
  <div class="bottom-nav">
    <div class="nav-container">
      <!-- Home -->
      <button 
        class="nav-item" 
        :class="{ active: activeTab === 'home', playing: $store.state.player.isPlaying && $store.state.currentPlayer === 'publication' }"
        @click="$router.push('/home')"
      >
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
        <span class="nav-label">Home</span>
      </button>

      <!-- Playlist -->
      <button 
        class="nav-item" 
        :class="{ active: activeTab === 'playLists', playing: $store.state.audioPlayerIsPlaying && $store.state.currentPlayer === 'audioPlayer' }"
        @click="$router.push('/playLists')"
      >
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 18V5l12-2v13"/>
          <circle cx="6" cy="18" r="3"/>
          <circle cx="18" cy="16" r="3"/>
        </svg>
        <span class="nav-label">Playlist</span>
      </button>

      <!-- Add Button (Center) -->
      <button 
        class="add-button"
        :class="{ active: activeTab === 'add' }"
        @click="$refs.publicationForm.show()"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
          <line x1="12" y1="5" x2="12" y2="19"/>
          <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </button>

      <!-- Inbox -->
      <button 
        class="nav-item" 
        :class="{ active: activeTab === 'inbox' }"
        @click="$router.push('/inbox')"
      >
        <div class="icon-wrapper">
          <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          <div class="notification-badge" v-if="inboxCount > 0">
            {{ inboxCount > 99 ? '99+' : inboxCount }}
          </div>
        </div>
        <span class="nav-label">Inbox</span>
      </button>

      <!-- Profile -->
      <button 
        class="nav-item" 
        :class="{ active: activeTab === 'profile' }"
        @click="$router.push('/profile/'+$store.state.user?.uid)"
      >
        <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
        <span class="nav-label">Profile</span>
      </button>
    </div>

    <!-- Home indicator line -->
    <div class="home-indicator"></div>
  </div>
    <PublicationForm ref="publicationForm"/>
</template>

<script>
import PublicationForm from '@/views/components/publicationForm/PublicationForm.vue';

export default {
  name: 'BottomNavMenu',
  components:{
    PublicationForm
  },
  data() {
    return {
      current: 'product',
      activeTab: 'home',
      inboxCount: 0
    }
  },
  methods: {
    getNumberOfUnreadMessage () {
      const messages = this.$store.state.messages;
      if (!messages) return;
      let totalUnread = 0
      // Iterate through all user conversations
      for (const userId in messages) {
        const userMessages = messages[userId];
        if (!userMessages || userMessages.length === 0) continue;

        
        // Count unread messages
        totalUnread += userMessages.filter(msg => 
          msg.senderId === userId && 
          !msg.seenAt && 
          !msg.deletedAt
        ).length;
        if(totalUnread > 100) break
      }
      return totalUnread
    }
  },
  watch: {
    '$route' (to/*, from*/) {
      this.activeTab = to.name
    },
    "$store.state.messages": {
      handler() {
        console.log('updating conversation-----------')
        this.inboxCount = this.getNumberOfUnreadMessage()
      },
      deep: true
    },
    '$store.state.modifyPublication.count' () {
      this.$refs.publicationForm.show('modify', this.$store.state.modifyPublication.publication)
    }
  },
  mounted () {
    //localStorage.clear()
    const pl = localStorage.getItem('playLists__')
    console.log(pl)
    let playlists = pl != null ? JSON.parse(pl) : []
    this.$store.commit('setPlayLists',playlists)

    // let's get users
    const users = localStorage.getItem('users');
    if (users) {
      console.log('users====',JSON.parse(users))
      this.$store.commit('setUsers', JSON.parse(users));
    }
    // always after users setting
    const user = localStorage.getItem('currentUser__')
    console.log(user)
    if(user != null) {
      let userInfos = JSON.parse(user)
      this.$store.commit('setUser',userInfos)
    }
    // let's set up messages data ( always after users) -----------
    const savedMessages = localStorage.getItem('messages');
    if (savedMessages) {
      console.log(JSON.parse(savedMessages))
      this.$store.commit('setMessages', JSON.parse(savedMessages));
    }

  }
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(10, 14, 38, 0.95);
  border-top: 1px solid rgba(0, 212, 255, 0.1);
  padding: 12px 0 20px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.5);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.nav-container {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;
}

.nav-item {
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 8px 12px;
  color: #94a3b8;
}

.nav-item:hover {
  color: #e0f7ff;
}

.nav-item.active {
  color: #00d4ff;
}

.nav-icon {
  width: 26px;
  height: 26px;
}


.nav-label {
  font-size: 12px;
  font-weight: 500;
}

.nav-item.active .nav-label {
  font-weight: 600;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
}

.add-button {
  background: linear-gradient(135deg, #ff006e, #8338ec);
  border: none;
  border-radius: 16px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  margin-top: -10px;
  color: #ffffff;
}

.add-button svg {
  width: 28px;
  height: 28px;
}
.add-button:hover,
.add-button.active {
  box-shadow: 0 0 25px rgba(255, 0, 110, 0.6);
}
.icon-wrapper {
  position: relative;
}

.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #ff006e, #ff4d94);
  color: #ffffff;
  font-size: 11px;
  font-weight: bold;
  border-radius: 12px;
  padding: 2px 7px;
  min-width: 24px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(255, 0, 110, 0.5);
  border: 2px solid rgba(10, 14, 38, 0.95);
}

.home-indicator {
  width: 140px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  margin: 16px auto 0;
  opacity: 0.5;
}

/* animated state when */

.nav-item.playing .nav-icon {
  color: #00d4ff;
  animation: pulse-icon 1.2s ease-in-out infinite;
}

.nav-item.playing .nav-label {
  color: #00d4ff;
}

@keyframes pulse-icon {
  0%, 100% { transform: scale(1);    opacity: 1; }
  50%       { transform: scale(1.2); opacity: 0.6; }
}
@media (max-width: 340px) {
  .nav-container {
    padding: 0 10px;
  }
  
  .nav-item {
    padding: 8px 8px;
  }
  
  .nav-label {
    font-size: 11px;
  }
}
</style>